(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["headx-exercise-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();
    const normalizeMarker = (value) => normalizeText(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[’'\-]/g, ' ')
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    const explanationMarkers = new Set([
      'why it matters', 'why this matters', 'why is this important',
      'warum ist das wichtig', 'warum das wichtig ist', 'warum es wichtig ist',
      'warum ist dies wichtig', 'weshalb ist das wichtig',
      'pourquoi c est important', 'pourquoi est ce important',
      'pourquoi cela est important', 'pourquoi cela compte',
      'por que es importante', 'por que esto es importante', 'por que importa',
      'perche e importante', 'perche questo e importante', 'perche conta'
    ]);
    const hasContent = (node) => Boolean(normalizeText(node.textContent)
      || (node.querySelector && node.querySelector('img, video, iframe, svg, canvas, table, hr')));
    const trimParagraphs = (root) => {
      root.querySelectorAll('p').forEach((paragraph) => {
        while (paragraph.firstChild && (
          (paragraph.firstChild.nodeType === 3 && !normalizeText(paragraph.firstChild.textContent))
          || paragraph.firstChild.nodeName === 'BR'
        )) paragraph.firstChild.remove();
        while (paragraph.lastChild && (
          (paragraph.lastChild.nodeType === 3 && !normalizeText(paragraph.lastChild.textContent))
          || paragraph.lastChild.nodeName === 'BR'
        )) paragraph.lastChild.remove();
        if (!hasContent(paragraph)) paragraph.remove();
      });
      while (root.firstChild && (
        (root.firstChild.nodeType === 3 && !normalizeText(root.firstChild.textContent))
        || root.firstChild.nodeName === 'BR'
      )) root.firstChild.remove();
      while (root.lastChild && (
        (root.lastChild.nodeType === 3 && !normalizeText(root.lastChild.textContent))
        || root.lastChild.nodeName === 'BR'
      )) root.lastChild.remove();
    };
    const prepareCopy = (panel) => {
      const copy = panel.querySelector('[data-hxe-copy]');
      const details = panel.querySelector('[data-hxe-about]');
      const aboutBody = panel.querySelector('[data-hxe-about-body]');
      if (!copy || !details || !aboutBody || copy.hasAttribute('data-hxe-prepared')) return;
      const strongElements = copy.querySelectorAll('strong');
      const marker = strongElements[strongElements.length - 1];
      if (!marker || !explanationMarkers.has(normalizeMarker(marker.textContent))) return;
      const range = document.createRange();
      range.setStartAfter(marker);
      range.setEnd(copy, copy.childNodes.length);
      const candidate = range.cloneContents();
      if (!Array.from(candidate.querySelectorAll('p')).some((paragraph) => hasContent(paragraph))) return;
      aboutBody.appendChild(range.extractContents());
      marker.remove();
      trimParagraphs(copy);
      trimParagraphs(aboutBody);
      let list = null;
      Array.from(copy.childNodes).forEach((node) => {
        if (node.nodeName === 'P') {
          if (!list) {
            list = document.createElement('ol');
            list.setAttribute('data-hxe-steps', '');
            copy.insertBefore(list, node);
          }
          const item = document.createElement('li');
          Array.from(node.attributes).forEach((attribute) => item.setAttribute(attribute.name, attribute.value));
          while (node.firstChild) item.appendChild(node.firstChild);
          list.appendChild(item);
          node.remove();
        } else if (node.nodeType !== 3 || normalizeText(node.textContent)) {
          list = null;
        }
      });
      copy.setAttribute('data-hxe-prepared', '');
      details.hidden = false;
    };
    const stopMedia = (panel) => {
      panel.querySelectorAll('[data-hxe-player] iframe').forEach((frame) => {
        frame.removeAttribute('src');
        frame.remove();
      });
      panel.querySelectorAll('[data-hxe-player] video').forEach((video) => {
        try { video.pause(); } catch (_) {}
      });
    };
    const prepareVideo = (panel) => {
      const player = panel.querySelector('[data-hxe-player]');
      const template = panel.querySelector('template[data-hxe-video-template]');
      if (!player || !template || player.querySelector('iframe, video')) return;
      const fragment = template.content.cloneNode(true);
      fragment.querySelectorAll('video').forEach((video) => {
        video.removeAttribute('autoplay');
        video.autoplay = false;
      });
      fragment.querySelectorAll('iframe').forEach((frame) => {
        const source = frame.getAttribute('src');
        if (!source) return;
        try {
          const url = new URL(source, window.location.href);
          url.searchParams.set('autoplay', '0');
          frame.setAttribute('src', url.href);
        } catch (_) {
          frame.removeAttribute('src');
        }
      });
      player.appendChild(fragment);
    };

    class HeadxExerciseHeader extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        const controller = this._controller;
        const updateLinks = () => {
          if (this.isConnected && this._controller === controller) this.preservePreviewLinks();
        };
        queueMicrotask(updateLinks);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', updateLinks, { once: true, signal: controller.signal });
        }
        this.addEventListener('click', (event) => {
          const anchor = event.target.closest('.hxe-library[href], .hxe-chapter-links a[href]');
          if (!anchor || !this.contains(anchor)) return;
          const target = this.destinationForChapter(anchor.getAttribute('href'));
          if (target) anchor.setAttribute('href', target.href);
        }, { signal: controller.signal });
        this.addEventListener('change', (event) => {
          const selector = event.target.closest('[data-hxe-chapter]');
          if (!selector || !this.contains(selector) || !selector.value) return;
          try {
            const target = this.destinationForChapter(selector.value);
            if (target && target.href !== window.location.href) window.location.assign(target.href);
          } catch (_) {}
        }, { signal: this._controller.signal });
      }

      preservePreviewLinks() {
        this.querySelectorAll('.hxe-library[href], .hxe-chapter-links a[href]').forEach((anchor) => {
          const target = this.destinationForChapter(anchor.getAttribute('href'));
          if (target) anchor.setAttribute('href', target.href);
        });
      }

      destinationForChapter(value) {
        try {
          const current = new URL(window.location.href);
          const target = new URL(value, current);
          if (target.origin !== current.origin || !/^https?:$/.test(target.protocol)) return null;
          ['preview_theme_id', 'pb'].forEach((key) => {
            if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
          });
          return target;
        } catch (_) {
          return null;
        }
      }

      disconnectedCallback() {
        if (this._controller) this._controller.abort();
        this._controller = null;
      }
    }

    class HeadxExerciseNavigator extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        const controller = this._controller;
        const initialize = () => {
          if (this.isConnected && this._controller === controller) this.initialize(controller.signal);
        };
        queueMicrotask(initialize);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: controller.signal });
        }
      }

      initialize(signal) {
        if (this._initialized) return;
        this._navigation = this.querySelector('[data-hxe-navigation]');
        this._selector = this.querySelector('[data-hxe-select]');
        const panels = Array.from(this.querySelectorAll('[data-hxe-panels] [data-hxe-panel]'));
        const tabs = this._navigation ? Array.from(this._navigation.querySelectorAll('[data-hxe-tab]')) : [];
        this._records = tabs.map((tab) => ({
          tab,
          index: tab.dataset.index,
          panel: panels.find((panel) => panel.dataset.index === tab.dataset.index)
        }));
        if (!this._records.length || this._records.some((record) => !record.panel)
          || panels.length !== this._records.length) return;
        this._initialized = true;
        this._previous = this.querySelector('[data-hxe-prev]');
        this._next = this.querySelector('[data-hxe-next]');
        this._count = this.querySelector('[data-hxe-count]');
        this._records.forEach((record) => {
          record.tab.setAttribute('aria-controls', record.panel.id);
          prepareCopy(record.panel);
        });
        this.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
          const anchor = event.target.closest('[data-hxe-tab], [data-hxe-prev], [data-hxe-next]');
          if (!anchor || !this.contains(anchor)) return;
          event.preventDefault();
          if (anchor.getAttribute('aria-disabled') === 'true') return;
          const record = this._records.find((item) => item.index === anchor.dataset.index);
          if (!record) return;
          this.selectRecord(record, {
            history: true,
            focus: anchor.hasAttribute('data-hxe-tab') ? 'navigation' : 'heading'
          });
        }, { signal });
        this.addEventListener('keydown', (event) => {
          const anchor = event.target.closest('[data-hxe-tab]');
          if (!anchor || !this._navigation.contains(anchor) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const position = this._records.findIndex((record) => record.tab === anchor);
          let target = position;
          if (event.key === 'ArrowUp') target = Math.max(0, position - 1);
          else if (event.key === 'ArrowDown') target = Math.min(this._records.length - 1, position + 1);
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = this._records.length - 1;
          else return;
          event.preventDefault();
          this.selectRecord(this._records[target], { history: true, focus: 'navigation' });
        }, { signal });
        if (this._selector) {
          this._selector.addEventListener('change', () => {
            const record = this._records.find((item) => item.index === this._selector.value);
            if (record) this.selectRecord(record, { history: true });
          }, { signal });
        }
        const restoreHash = () => {
          const record = this.recordFromHash();
          if (record) this.selectRecord(record);
          else if (!window.location.hash) this.selectRecord(this._records[0]);
        };
        window.addEventListener('hashchange', restoreHash, { signal });
        window.addEventListener('popstate', restoreHash, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail && event.detail.blockId;
          const sectionId = event.detail && event.detail.sectionId;
          if (sectionId && sectionId !== this.dataset.sectionId) return;
          const record = this._records.find((item) => item.panel.dataset.blockId === blockId);
          if (record && (this.contains(event.target) || sectionId === this.dataset.sectionId)) {
            this.selectRecord(record);
          }
        }, { signal });
        this.classList.add('is-enhanced');
        this.selectRecord(this.recordFromHash() || this._records[0]);
      }

      recordFromHash() {
        try {
          const id = decodeURIComponent(window.location.hash.slice(1));
          return this._records.find((record) => record.panel.id === id);
        } catch (_) {
          return undefined;
        }
      }

      updateAdjacent(anchor, record) {
        if (!anchor) return;
        const title = anchor.querySelector('[data-hxe-nav-title]');
        if (title) title.textContent = record ? normalizeText(record.tab.textContent) : '';
        if (!record) {
          anchor.setAttribute('aria-disabled', 'true');
          anchor.setAttribute('tabindex', '-1');
          anchor.removeAttribute('href');
          anchor.removeAttribute('data-index');
          anchor.removeAttribute('aria-controls');
          return;
        }
        anchor.removeAttribute('aria-disabled');
        anchor.removeAttribute('tabindex');
        anchor.setAttribute('href', '#' + record.panel.id);
        anchor.setAttribute('aria-controls', record.panel.id);
        anchor.dataset.index = record.index;
      }

      selectRecord(record, options = {}) {
        if (!record) return;
        const position = this._records.indexOf(record);
        if (position < 0) return;
        const oldFocus = document.activeElement;
        const focusWasInHiddenPanel = this._records.some((item) => item !== record && item.panel.contains(oldFocus));
        this._records.forEach((item) => {
          const selected = item === record;
          item.panel.hidden = !selected;
          if (selected) item.tab.setAttribute('aria-current', 'true');
          else {
            item.tab.removeAttribute('aria-current');
            stopMedia(item.panel);
          }
        });
        this._activeRecord = record;
        if (this._selector) this._selector.value = record.index;
        const count = record.panel.querySelector('[data-hxe-count]') || this._count;
        if (count) {
          const label = this.dataset.countLabel || 'Exercise {current} of {total}';
          count.textContent = label
            .replace(/\{\{\s*current\s*\}\}|\{current\}/g, String(position + 1))
            .replace(/\{\{\s*total\s*\}\}|\{total\}/g, String(this._records.length));
        }
        this.updateAdjacent(this._previous, this._records[position - 1]);
        this.updateAdjacent(this._next, this._records[position + 1]);
        prepareVideo(record.panel);
        if (options.history) {
          const target = new URL(window.location.href);
          target.hash = record.panel.id;
          if (target.href !== window.location.href) window.history.pushState(window.history.state, '', target.href);
        }
        if (options.focus === 'navigation') record.tab.focus();
        else if (options.focus === 'heading' || focusWasInHiddenPanel) {
          const heading = record.panel.querySelector('[data-hxe-title]');
          if (heading) heading.focus();
        }
      }

      disconnectedCallback() {
        if (this._controller) this._controller.abort();
        if (this._records) this._records.forEach((record) => { if (record.panel) stopMedia(record.panel); });
        this._controller = null;
        this._initialized = false;
      }
    }

    if (!customElements.get('headx-exercise-header')) customElements.define('headx-exercise-header', HeadxExerciseHeader);
    if (!customElements.get('headx-exercise-navigator')) customElements.define('headx-exercise-navigator', HeadxExerciseNavigator);
  })();
  } catch(e) { console.error(e); }
})();

})();
